import { Directive, HostBinding, Input } from '@angular/core';

@Directive({
  /* eslint-disable-next-line @angular-eslint/directive-selector */
  selector: 'div[UIKitTabContentItem]',
})
export class TabsContentItemDirective {
  // @ts-expect-error
  @Input() active: boolean;

  @HostBinding('class')
  get classes() {
    return `tab-content ${!this.active ? 'invisible' : 'active'}`;
  }
  constructor() {}
}
